class ProductImageSlider extends HTMLElement {
  constructor() {
    super();
    this.splide = new Splide(".component--product--media__slider", {
      pagination: false,
      arrows: false,
    });
    this.thumbnails = document.getElementsByClassName(
      "component--product--media__thumbnail"
    );
    this.current;
    for (let i = 0; i < this.thumbnails.length; i++) {
      this.thumbnails[i].addEventListener("click", () => {
        this.splide.go(i);
      });
    }
    this.splide.on("mounted move", () => {
      let thumbnail = this.thumbnails[this.splide.index];
      if (thumbnail) {
        if (this.current) {
          this.current.classList.remove("is-active");
        }
        thumbnail.classList.add("is-active");
        this.current = thumbnail;
      }
    });
    this.splide.mount();
  }
  bindEvents() {
    this.thumbnails.forEach((item, index) =>
      item.addEventListener("click", this.initThumbnail(index).bind(this))
    );
  }
  initThumbnail(index) {
    this.splide.go(index);
  }
}
customElements.define("product-image-slider", ProductImageSlider);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.slider = document.querySelector("product-image-slider");
    this.productFormBar = document.querySelector("product-form-bar");
    this.addEventListener("change", this.onVariantChange);
    this.updateOptions();
    this.updateMasterId();
    this.updateMediaByVariant();
    this.forms = document.querySelectorAll(`product-form[data-section="${this.dataset.section}"], product-form-bar[data-section="${this.dataset.section}"]`);
    this.bundleSelectsTemplate = document.querySelector(`bundle-selects-template[data-section="${this.dataset.section}"]`);
    this.bundleBasketItemTemplate = document.querySelector(`bundle-basket-item-template[data-section="${this.dataset.section}"]`);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    for(const form of this.forms){
      form.toggleAddButton(true, "", false);
    }
    if (!this.currentVariant) {
      for(const form of this.forms){
        form.toggleAddButton(true, "", true);
        form.setUnavailable();
      }
    } else {
      this.updateMediaByVariant();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateFormBar();
      if(this.bundleSelectsTemplate){
        this.updateBundleSelects();
      }
    }
  }
  updateFormBar() {
    const v = this.currentVariant.options;
    let i = '';
    if (this.currentVariant.featured_image) {
      i = this.currentVariant.featured_image.src;
    }
    this.productFormBar.updateVariant(v, i);
  }
  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }
  updateMediaByVariant() {
    const variantMedia = document.querySelectorAll("[data-variants]");
    variantMedia.forEach((item, index) => {
      const value = item.getAttribute("data-variant-id");
      if(value == this.currentVariant.id){
        this.slider.splide.go(index);
      }
    });
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }
  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
  updateBundleSelects() {
    this.bundleSelectsTemplate.onVariantChange(this.currentVariant.id);
    this.bundleBasketItemTemplate.onVariantChange(this.currentVariant.metafields.simple_bundles__variant_options);
  }
  updateSubscription(responseText) {
    const id = "product-recharge-selector";
    const html = new DOMParser().parseFromString(responseText, "text/html");
    const widget = document.getElementById(id);
    const source = html.getElementById(id);
    widget.innerHTML = source.innerHTML;
    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    addButtons.forEach((addButton) => {
      const qty = addButton.querySelector('[name="quantity"]').value;
      if (document.querySelector("product-subscription-selector")) {
        let onetimePriceElement = document.querySelector(
          "[data-onetime-price]"
        );
        let recurringPriceElement = document.querySelector(
          "[data-recurring-price]"
        );
        let onetimePrice =
          onetimePriceElement.getAttribute("data-onetime-price");
        let recurringPrice = recurringPriceElement.getAttribute(
          "data-recurring-price"
        );
        const newOnetimePrice = JSON.parse(onetimePrice) * JSON.parse(qty);
        const newRecurringePrice = JSON.parse(recurringPrice) * JSON.parse(qty);
        onetimePriceElement.innerHTML = formatMoney(newOnetimePrice);
        recurringPriceElement.innerHTML = formatMoney(newRecurringePrice);
        this.sub = document.querySelector("product-subscription-selector");
        if (this.sub.isSubscription === true) {
          document
            .querySelector("#product-recharge-selector__once")
            .removeAttribute("checked");
          document.querySelector(
            "#product-recharge-selector__once"
          ).checked = false;
          document
            .querySelector("#product-recharge-selector__recurring")
            .setAttribute("checked", "true");
          document.querySelector(
            "#product-recharge-selector__recurring"
          ).checked = true;
          this.sub.selectSubscription();
        }
      }
    });
  }
  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const selector = `.price-${this.dataset.section}`;
        const selectorMobile = `.price-${this.dataset.section}-mobile`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.querySelectorAll(selector);
        const source = html.querySelectorAll(selector);
        const destinationM = document.querySelectorAll(selectorMobile);
        const sourceM = html.querySelectorAll(selectorMobile);
        if (source && destination) {
          for(let i=0; i<destination.length; i++){
            destination[i].innerHTML = source[i].innerHTML;
          }
        }
        if (sourceM && destinationM) {
          for(let i=0; i<destinationM.length; i++){
            destinationM[i].innerHTML = sourceM[i].innerHTML;
          }
        }
        const prices = document
          .querySelectorAll(selectorMobile);
        prices.forEach((price) => { price.classList.remove("visibility-hidden"); });
        const pricesMobile = document
          .querySelectorAll(selectorMobile);
        pricesMobile.forEach((price) => { price.classList.remove("visibility-hidden"); });
        
        for(const form of this.forms){
          let text = ""
          if(!this.currentVariant.available){
            text = window.variantStrings.soldOut;
          }
          form.toggleAddButton(
            !this.currentVariant.available,
            text
          );
        }

        if (document.getElementById("product-recharge-selector"))
          this.updateSubscription(responseText);
      });
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  updateFormOptions() {
    const fieldsets = Array.from(
      document.querySelectorAll(".product-form__input")
    );
    fieldsets.map((fieldset) => {
      Array.from(fieldset.querySelectorAll("input")).find((radio) => {
        this.options.find((option) => {
          if (option == radio.value) {
            radio.checked = true;
          }
        });
      });
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
    this.updateFormOptions();
  }
}
customElements.define("variant-radios", VariantSelects);
class ProductQuantitySelector extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-bar`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="quantity"]');
      input.value = this.input.value;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      //console.log(this.input.value)
      this.updateSubscriptionSelector(this.input.value);
      this.updateButton(this.input.value);
    });
  }
  updateButton(qty) {
    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    for(let addButton of addButtons){
      addButton = addButton?.querySelector('[name="add"]');
      if (!addButton) continue;
      if (!addButton.textContent.includes('Add to Cart')) continue;
      const price = addButton.getAttribute("data-product-price");
      addButton.textContent =
        window.variantStrings.addToCart +
        " — " +
        formatMoney(JSON.parse(price) * qty);
    }
    const totalPriceElem = document.querySelector(`.component--bab--qty-price .component--product--price__item--regular`);
    if(totalPriceElem){
      const price = addButtons[0].querySelector('[name="add"]').getAttribute("data-product-price");
      const newPriceCents = JSON.parse(price) * qty;
      let newPriceString = formatMoney(newPriceCents);
      if(newPriceCents > 5000){
        newPriceString += `<small>&nbsp;with free shipping (contiguous US)</small>`;
      }
      totalPriceElem.innerHTML = newPriceString;
    }
  }
  updateSubscriptionSelector(qty) {
    if (document.querySelector("product-subscription-selector")) {
      let onetimePriceElement = document.querySelector("[data-onetime-price]");
      let recurringPriceElement = document.querySelector(
        "[data-recurring-price]"
      );
      let onetimePrice = onetimePriceElement.getAttribute("data-onetime-price");
      let recurringPrice = recurringPriceElement.getAttribute(
        "data-recurring-price"
      );
      const newOnetimePrice = JSON.parse(onetimePrice) * JSON.parse(qty);
      const newRecurringePrice = JSON.parse(recurringPrice) * JSON.parse(qty);
      onetimePriceElement.innerHTML = formatMoney(newOnetimePrice);
      recurringPriceElement.innerHTML = formatMoney(newRecurringePrice);
    }
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
    this.updateVariantInput();
  }
}
customElements.define("product-quantity-selector", ProductQuantitySelector);
class ProductSubscriptionSelector extends HTMLElement {
  constructor() {
    super();
    this.onetime = document.querySelector("#product-recharge-selector__once");
    this.subscription = document.querySelector(
      "#product-recharge-selector__recurring"
    );
    this.plans = document.querySelector(".js-selling-plans");
    this.isSubscription = false;
    this.addEventListener("change", this.onChange);
  }
  bindEvents() {
    document.addEventListener("DOMContentLoaded", () => {
      this.onetime.addEventListener("click", this.selectOneTime.bind(this));
      this.subscription.addEventListener(
        "click",
        this.selectSubscription.bind(this)
      );
    });
  }
  onChange() {
    this.updateForm();
    if (this.option.value == "true") {
      this.selectSubscription();
    } else {
      this.selectOneTime();
    }
  }
  updateButton(price) {
    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    addButtons.forEach((addButton) => {
      const qty = addButton.querySelector('[name="quantity"]').value;
      //console.log(qty)
      addButton = addButton?.querySelector('[name="add"]');
      if (!addButton) return;
      const total = JSON.parse(price) * JSON.parse(qty);
      addButton.setAttribute("data-product-price", price);
      addButton.textContent =
        window.variantStrings.addToCart + " — " + formatMoney(total);
    });
  }
  selectOneTime() {
    this.isSubscription = false;
    document.querySelector(".js-selling-plans").style.display = "none";
    this.querySelector(".product-recharge-selector__mode--once").classList.add(
      "product-recharge-selector__mode--active"
    );
    this.querySelector(
      ".product-recharge-selector__mode--recurring"
    ).classList.remove("product-recharge-selector__mode--active");
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-bar`
    );
    productForms.forEach((productForm) => {
      const ele = productForm.querySelector('input[name="selling_plan"]');
      ele.parentNode.removeChild(ele);
    });
    const price = this.querySelector(
      ".product-recharge-selector__mode--once"
    ).getAttribute("data-price");
    this.updateButton(price);
  }
  selectSubscription() {
    this.isSubscription = true;
    document.querySelector(".js-selling-plans").style.display = "block";
    this.querySelector(
      ".product-recharge-selector__mode--once"
    ).classList.remove("product-recharge-selector__mode--active");
    this.querySelector(
      ".product-recharge-selector__mode--recurring"
    ).classList.add("product-recharge-selector__mode--active");
    this.updateOptions();
    // create input
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-bar`
    );
    productForms.forEach((productForm) => {
      if (productForm.querySelector('input[name="selling_plan"]')) {
        productForm
          .querySelector('input[name="selling_plan"]')
          .setAttribute("value", this.plan.value);
      } else {
        let input = document.createElement("input");
        input.type = "hidden";
        input.setAttribute("name", "selling_plan");
        input.setAttribute("value", this.plan.value);
        productForm.appendChild(input);
      }
    });
    const price = this.querySelector(
      ".product-recharge-selector__mode--recurring"
    ).getAttribute("data-price");
    this.updateButton(price);
  }
  updateOptions() {
    this.plan = Array.from(
      this.querySelectorAll(".product-recharge-selector__frequency-input")
    ).find((radio) => radio.checked);
    Array.from(
      this.querySelectorAll(".product-recharge-selector__frequency-input")
    ).find((radio) => {
      if (this.plan.value == radio.value) {
        radio.checked = true;
        radio.setAttribute("checked", "");
      } else {
        radio.checked = false;
        radio.removeAttribute("checked");
      }
    });
  }
  updateForm() {
    this.option = Array.from(
      this.querySelectorAll(".product-recharge-selector__mode-input")
    ).find((radio) => radio.checked);
    Array.from(
      this.querySelectorAll(".product-recharge-selector__mode-input")
    ).find((radio) => {
      if (this.option.value == radio.value) {
        radio.checked = true;
        radio.setAttribute("checked", "");
      } else {
        radio.checked = false;
        radio.removeAttribute("checked");
      }
    });
  }
}
customElements.define(
  "product-subscription-selector",
  ProductSubscriptionSelector
);
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-drawer");
    this.variantSelects = document.querySelector(`variant-radios[data-section="${this.dataset.section}"]`);
    //this.toggleAddButton(false, "", false);
    this.bundleOptions = document.querySelector(`bundle-options[data-section="${this.dataset.section}"]`);
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);

    if(submitButton.classList.contains("select-flavor")){
      this.bundleOptions.open();
      if(window.innerWidth >= 768){
        window.scrollTo({top: 0, behavior: 'smooth'});
        this.bundleOptions.pendingSelection();
      }
    } else {
      const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      config.body = formData;

      for (const pair of formData.entries()) {
        //console.log(`${pair[0]}, ${pair[1]}`);
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.text())
        .then((state) => {
          this.cart.updateCart();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.removeAttribute("disabled");
        });
    }
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButtons = this.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    addButtons.forEach((addButton) => {
      const qty = addButton.querySelector('[name="quantity"]').value;
      addButton = addButton?.querySelector('[name="add"]');
      const bundleSelects = this.querySelectorAll(
        `[data-simple-bundles-prop]`
      );
      if(bundleSelects){
        let missingBundleSelect = false;
        for(const select of bundleSelects) {
          if(select.value === "") {
            missingBundleSelect = true;
            break;
          }
        }
        if(missingBundleSelect){
          disable = false;
          text = "Select Flavors";
          addButton.classList.add("select-flavor");
        } else {
          addButton.classList.remove("select-flavor");
        }
      }
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute("disabled", "");
        if (text) addButton.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        const total = JSON.parse(this.variantSelects.currentVariant.price) * JSON.parse(qty);
        addButton.setAttribute("data-product-price", this.variantSelects.currentVariant.price);
        if (text){
            addButton.textContent = text;
        } else {
          addButton.textContent = window.variantStrings.addToCart + " — " + formatMoney(total);
        }
      }
      if (!modifyClass) return;
    });
  }
  setUnavailable() {
    const addButtons = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    addButtons.forEach((addButton) => {
      addButton = addButton?.querySelector('[name="add"]');
      if (!addButton) return;
      addButton.textContent = window.variantStrings.unavailable;
      const prices = document
          .querySelectorAll(`.price-${this.dataset.section}`);
        prices.forEach((price) => { price.classList.add("visibility-hidden"); });
    });
  }
}
customElements.define("product-form", ProductForm);
class ProductFormBar extends HTMLElement {
  constructor() {
    super();
    this.bar = this.querySelector(".component--product--form-bar");
    this.footer = document.querySelector(".global--footer");
    this.container = document.querySelector(".component--product-form");
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cart = document.querySelector("cart-drawer");
    this.variantSelects = document.querySelector(`variant-radios[data-section="${this.dataset.section}"]`);
    this.bundleOptions = document.querySelector(`bundle-options[data-section="${this.dataset.section}"]`);
    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener("scroll", this.toggle.bind(this));
  }
  updateVariant(values, image) {
    const ele = document.querySelectorAll(
      ".component--product--form-bar__value"
    );
    const imageElement = document.querySelector(
      ".component--product--form-bar__image"
    );
    ele.forEach((e, i) => {
      e.innerHTML = values[i];
    });
    imageElement.src = image;
  }
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitButton = this.querySelector('[type="submit"]');
    submitButton.setAttribute("disabled", true);

    if(submitButton.classList.contains("select-flavor")){
      this.bundleOptions.open();
      this.bundleOptions.pendingSelection();
      if(window.innerWidth >= 768){
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
    } else {
      const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append("sections", this.cart.getSectionsToRender().map((section) => section.id));
      formData.append("sections_url", window.location.pathname);
      config.body = formData;

      /*
      config.body = {
        formData,
        sections: this.cart.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      };
      */

      console.log(config);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.cart.renderContents(parsedState);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.removeAttribute("disabled");
        });
      }
  }
  inViewport(el) {
    const rect = el.getBoundingClientRect();
    const vWidth = window.innerWidth || document.documentElement.clientWidth;
    const vHeight = window.innerHeight || document.documentElement.clientHeight;
    const efp = function (x, y) {
      return document.elementFromPoint(x, y);
    };
    // Return false if it's not in the viewport
    if (
      rect.right < 0 ||
      rect.bottom < 0 ||
      rect.left > vWidth ||
      rect.top > vHeight
    ) {
      return false;
    }
    // Return true if any of its four corners are visible
    return (
      el.contains(efp(rect.left, rect.top)) ||
      el.contains(efp(rect.right, rect.top)) ||
      el.contains(efp(rect.right, rect.bottom)) ||
      el.contains(efp(rect.left, rect.bottom))
    );
  }
  toggle() {
    const visible = this.inViewport(this.container);
    if (visible) {
      this.bar.classList.remove("component--product--form-bar--active");
      this.footer.classList.remove("global--footer--padding");
    } else {
      this.bar.classList.add("component--product--form-bar--active");
      this.footer.classList.add("global--footer--padding");
    }
  }
  show(){
    this.bar.classList.add("component--product--form-bar--active");
    this.footer.classList.add("global--footer--padding");
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButtons = this.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment, #product-form-bar`
    );
    addButtons.forEach((addButton) => {
      const qty = addButton.querySelector('[name="quantity"]').value;
      addButton = addButton?.querySelector('[name="add"]');
      const bundleSelects = this.querySelectorAll(
        `[data-simple-bundles-prop]`
      );
      if(bundleSelects){
        let missingBundleSelect = false;
        for(const select of bundleSelects) {
          if(select.value === "") {
            missingBundleSelect = true;
            break;
          }
        }
        if(missingBundleSelect){
          disable = false;
          text = "Select Flavors";
          addButton.classList.add("select-flavor");
        } else {
          addButton.classList.remove("select-flavor");
        }
      }
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute("disabled", "");
        if (text) addButton.textContent = text;
      } else {
        addButton.removeAttribute("disabled");
        const total = JSON.parse(this.variantSelects.currentVariant.price) * JSON.parse(qty);
        addButton.setAttribute("data-product-price", this.variantSelects.currentVariant.price);
        if (text){
            addButton.textContent = text;
        } else {
          addButton.textContent = window.variantStrings.addToCart + " — " + formatMoney(total);
        }
      }
      if (!modifyClass) return;
    });
  }
}
customElements.define("product-form-bar", ProductFormBar);
class ProductTabs extends HTMLElement {
  constructor() {
    super();
    this.footerAccordions = document.querySelectorAll(
      ".component--product-accordion__titles"
    );
    this.bindEvents();
  }
  bindEvents() {
    this.footerAccordions.forEach((accordion) =>
      accordion.addEventListener("click", this.toggleFooterAccordion.bind(this))
    );
  }
  toggleFooterAccordion(event) {
    const element = event.currentTarget;
    const toggle = !JSON.parse(element.getAttribute("aria-expanded"));
    element.setAttribute("aria-expanded", toggle);
  }
}
customElements.define("product-tabs", ProductTabs);
class BundleProductModal extends HTMLElement {
  constructor() {
    super();
    this.opener = this.querySelector("[data-bundle-product-trigger]");
    this.closeButton = this.querySelector("[data-bundle-product-close]");
    this.drawer = this.querySelector(".component--bundle-product--modal");
    this.bindEvents();
  }
  bindEvents() {
    this.opener.addEventListener("click", this.open.bind(this));
    this.closeButton.addEventListener("click", this.close.bind(this));
  }
  close(event) {
    document.body.classList.remove("is-overlay-opened");
    this.drawer.classList.remove("component--bundle-product--modal--active");
  }
  open(event) {
    document.body.classList.add("is-overlay-opened");
    this.drawer.classList.add("component--bundle-product--modal--active");
  }
}
customElements.define("bundle-product-modal", BundleProductModal);

//variant bundle inputs html for variant switching
class BundleSelectsTemplate extends HTMLElement {
  constructor() {
    super();
  }
  onVariantChange(variantID) {
    const content = this.querySelector(`[data-simple-bundle-variant="${variantID}"]`).innerHTML;
    document.querySelectorAll(`form-bundle-selects[data-section="${this.dataset.section}"]`).forEach((formBundleSelects) => {
      formBundleSelects.replaceContent(content);
    });
  }
}
customElements.define("bundle-selects-template", BundleSelectsTemplate);

//hidden bundle inputs on ATC form for submitting
class FormBundleSelects extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init(){
    this.forms = document.querySelectorAll(`product-form[data-section="${this.dataset.section}"], product-form-bar[data-section="${this.dataset.section}"]`);
    this.selectsWrap = this.querySelector("[data-selects-wrap]");
    this.selects = this.querySelectorAll("[data-simple-bundles-prop]");
    this.selection = this.querySelector('[data-simple-bundles-selection]');
    this.selects.forEach((select) =>
      select.addEventListener("change", this.updateForm.bind(this))
    );
    this.selects.forEach((select) => {
      select.addEventListener("change", this.onSelectChange);
    });
    document.addEventListener('DOMContentLoaded', this.refreshSelects.bind(this));
  }
  refreshSelects() {
    this.selects.forEach((select) => {
      select.dispatchEvent(new Event('change'));
    });
  }
  updateForm() {
    let selects = [];
    let missingValue = false;
    this.selects.forEach(select => {
      selects.push(select.value)
      if(select.value === ""){
        missingValue = true;
      }   
    });
    if(missingValue){
      for(const form of this.forms){
        form.toggleAddButton(true,"",false);
      }
    } else {
      for(const form of this.forms){
        form.toggleAddButton(false,"",false);
      }
    }
    if(this.selection){
      this.selection.value = selects.join(" <> ");
    }
  }
  onSelectChange() {
    const basketItem = document.querySelector(`bundle-basket-item[data-section="${this.dataset.section}"][data-option-name="${this.dataset.name}"]`);
    const optionItems = document.querySelectorAll(`bundle-option-item[data-section="${this.dataset.section}"]`);
    const selectedOption = this.querySelector("option:checked");
    basketItem.updateContent(selectedOption.dataset.bagFrontImage, selectedOption.dataset.productTitle, selectedOption.dataset.solidColor, selectedOption.dataset.tintColor);
    optionItems.forEach((optionItem) => {
      optionItem.updateContent();
    });
  }
  replaceContent(content) {
    this.selectsWrap.innerHTML = content;
    this.init();
    this.selects[0].dispatchEvent(new Event('change'));
  }
}
customElements.define("form-bundle-selects", FormBundleSelects);

//clicking on item in bundle basket
class BundleBasketItem extends HTMLElement {
  constructor() {
    super();
    document.addEventListener("click", this.onClick.bind(this))
    this.itemImage = this.querySelector(".bundle-basket-item__image");
    this.itemTitle = this.querySelector(".bundle-basket-item__title");
    this.bundleOptions = document.querySelector(`bundle-options[data-section="${this.dataset.section}"]`);
    this.querySelector(`.bundle-basket-item--full__button`).addEventListener("click", this.removeItem.bind(this));
  }
  onClick(event) {
    const element = event.target;
    if(!this.contains(element)){
      this.classList.remove("selected");
      if(!element.classList.contains("bundle-basket-item__button")){
        this.bundleOptions.notPendingSelection();
      }
    } else {
      this.classList.add("selected");
      this.bundleOptions.open();
      if(window.innerWidth >= 768){
        window.scrollTo({top: 0, behavior: 'smooth'});
        this.bundleOptions.pendingSelection();
      }
    }
  }
  updateContent(image, title, solidColor, tintColor) {
    if(title !== undefined){
      this.itemImage.src = image;
      this.itemImage.alt = title;
      this.itemTitle.innerHTML = title;
    }
    if(title === undefined){
      this.classList.remove("bundle-basket-item--full");
      this.classList.add("bundle-basket-item--empty");
    } else {
      this.classList.remove("bundle-basket-item--empty");
      this.classList.add("bundle-basket-item--full");
    }
  }
  removeItem(){
    const selects = document.querySelectorAll(`form-bundle-selects[data-section="${this.parentNode.dataset.section}"] select[data-name="${this.dataset.optionName}"]`);
    for(const select of selects){
      select.value = "";
      select.dispatchEvent(new Event('change'));
    }
  }
}
customElements.define("bundle-basket-item", BundleBasketItem);

//bundle basket html for variant switching
class BundleBasketItemTemplate extends HTMLElement {
  constructor() {
    super();
  }
  onVariantChange(simple_bundles__variant_options) {

    const basket = document.querySelector(`bundle-basket[data-section="${this.dataset.section}"]`);
    basket.dataset.count = simple_bundles__variant_options.length;
    basket.dataset.columns = Math.min(Math.max(Math.round(simple_bundles__variant_options.length/3),3),6);

    let manyContent = "";
    for (let i = 0; i < simple_bundles__variant_options.length; i++) {
      const content = this.cloneNode(true);
      content.querySelector('bundle-basket-item').dataset.optionName = simple_bundles__variant_options[i].optionName;
      manyContent += content.innerHTML;
    }
    basket.innerHTML = manyContent;
  }
}
customElements.define("bundle-basket-item-template", BundleBasketItemTemplate);

class BundleOptions extends HTMLElement {
  constructor() {
    super();
    this.querySelector(`.component--product--bundle-options__close`).addEventListener("click", this.close.bind(this));
    this.productFormBar = document.querySelector("product-form-bar");
  }
  open(){
    document.body.classList.add("bundle-options-active");
    this.querySelector(`.bundle-option-item__button`).focus();
    this.productFormBar.show();
  }
  close() {
    document.body.classList.remove("bundle-options-active");
    const focus = document.querySelector(`bundle-basket-item[data-section="${this.dataset.section}"].bundle-basket-item--empty`);
    if(!focus){
      focus = document.querySelector(`#product-form-${this.dataset.section}`);
    }
    focus.focus();
  }
  pendingSelection(){
    this.classList.add("pending-selection");
  }
  notPendingSelection(){
    this.classList.remove("pending-selection");
  }
}
customElements.define("bundle-options", BundleOptions);

//bundle option item html for variant switching
class BundleOptionItemTemplate extends HTMLElement {
  constructor() {
    super();
  }
  onVariantChange(count) {
    
  }
}
customElements.define("bundle-option-item-template", BundleOptionItemTemplate);

//bundle option item selection
class BundleOptionItem extends HTMLElement {
  constructor() {
    super();
    this.buttons = this.querySelectorAll(".bundle-option-item__button");
    this.buttons.forEach((button) => {
      button.addEventListener("click", this.onClick);
    });
    this.itemCount = this.querySelector(".bundle-option-item__count");
  }
  onClick() {
    const opacity = window.getComputedStyle(this.parentNode.querySelector('.bundle-option-item__hover')).getPropertyValue("opacity");
    if(opacity != 1){
      this.focus();
      return;
    }
    const formBundleSelects = document.querySelectorAll(`form-bundle-selects[data-section="${this.parentNode.dataset.section}"]`);
    const isAdd = this.classList.contains("show--add");
    const basketSelected = document.querySelector(`bundle-basket-item[data-section="${this.parentNode.dataset.section}"].selected`);
    let selectName = false;
    if(basketSelected){
      selectName = basketSelected.dataset.optionName;
    }

    for(const [i,formBundleSelect] of formBundleSelects.entries()){
      const selects = formBundleSelect.querySelectorAll(`select`);
      let empty = 0;
      let count = 0;
      let complete = false;
      let removedValue = false;
      for(const select of selects){
        let hasOption = select.querySelector(`option[value="${this.value}"]`);
        if(hasOption){
          if(select.value === ''){
            empty ++;
          }
          if(selectName && isAdd){
            if(select.dataset.name == selectName){
              if(select.value === ''){
                empty --;
              }
              select.value = this.value;
              select.dispatchEvent(new Event('change'));
              complete = true;
            }
          } else if(!complete){
            if(isAdd && select.value === ''){
              select.value = this.value;
              select.dispatchEvent(new Event('change'));
              empty --;
              complete = true;
            } else if(!isAdd && select.value == this.value){
              select.value = "";
              select.dispatchEvent(new Event('change'));
              empty ++;
              complete = true;
            }
          }
        }
      }
      if(isAdd && empty == 0 && !complete){
        for(const select of selects){
          let hasOption = select.querySelector(`option[value="${this.value}"]`);
          if(hasOption){
            removedValue = select.value;
            select.value = this.value;
            select.dispatchEvent(new Event('change'));
            complete = true;
            break;
          }
        }
      }

      if(complete && i == 0){
        this.parentNode.classList.add("complete");
        setTimeout(() => {
          this.parentNode.classList.remove("complete");
        }, 500);
      }
    }
  }
  updateContent(){
    const formBundleSelect = document.querySelector(`form-bundle-selects[data-section="${this.dataset.section}"]`);
    const selects = formBundleSelect.querySelectorAll(`select`);
    let count = 0;
    let empty = 0;

    for(const select of selects){
      if(select.value == this.dataset.value){
        count ++;
      } else if(select.value == ""){
        empty++;
      }
    }
    this.itemCount.innerHTML = count;
    this.dataset.count = count;
    if(empty == 0){
      if(count > 0){
        this.classList.add("bundle-option-item--remove");
        this.classList.remove("bundle-option-item--add");
      } else {
        this.classList.remove("bundle-option-item--remove");
        this.classList.add("bundle-option-item--add");
      }
    } else {
      this.classList.remove("bundle-option-item--remove");
      this.classList.add("bundle-option-item--add");
    }
  }
}
customElements.define("bundle-option-item", BundleOptionItem);